import React from "react";
import {PolicyModal} from "./PolicyModal";
import {privacyPolicyHtml} from "../../components/shared/policyDocuments";

export function PrivacyModal({isOpen, onClose}) {
    return (
            <PolicyModal
            isOpen={isOpen}
            onClose={onClose}
            title={"Privacy Policy"}
            contentHtml={privacyPolicyHtml}
        />
    );
}
